import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return data.url;
}

export function UploadButton({ onUploaded, multiple = false, label = "Upload", testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) onUploaded(await uploadFile(f), f);
      toast.success(`${files.length} image${files.length > 1 ? "s" : ""} uploaded`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" multiple={multiple} hidden onChange={onChange} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={testid}
        className="inline-flex items-center gap-2 border border-[#e2dcd4] bg-white px-4 py-2 text-sm hover:border-[#1f402b] disabled:opacity-60">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
